import { render, staticRenderFns } from "./Jurusan.vue?vue&type=template&id=2d142a02&"
import script from "./Jurusan.vue?vue&type=script&lang=js&"
export * from "./Jurusan.vue?vue&type=script&lang=js&"
import style0 from "./Jurusan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports